import { useSpring, animated } from "@react-spring/web";
import Draggable from "react-draggable";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DraggableWrapper = ({ open, onClose,width=300, children }) => {
    // Animation for smooth open/close
    const animation = useSpring({
        opacity: open ? 1 : 0,
        transform: open ? "translateY(0px) scale(1)" : "translateY(20px) scale(0.9)",
        config: { tension: 200, friction: 15 },
    });

    if (!open) return null;

    return (
        <Draggable>
            <animated.div style={{ ...animation, position: "fixed", top: 100, left: 100, zIndex: 99999 }}>
                <Box
                    sx={{
                        width: width,
                        background: "white",
                        border: "1px solid #ccc",
                        borderRadius: 2,
                        boxShadow: 3,
                        p: 1.5,
                        cursor: "move",
                        zIndex: 9999,
                    }}
                >
                    {/* Close Button */}
                    <Box display="flex" justifyContent="flex-end">
                        <IconButton
                            onClick={onClose}
                            sx={{
                                p: 0, // Remove padding
                                width: "16px", // Set fixed small size
                                height: "16px",
                                minWidth: "16px",
                                minHeight: "16px",
                                color: "red"
                            }}
                        >
                            <CloseIcon sx={{ fontSize: "10px" }} /> {/* Tiny icon */}
                        </IconButton>
                    </Box>




                    {/* Dynamic Child Content */}
                    {children}
                </Box>
            </animated.div>
        </Draggable>
    );
};

export default DraggableWrapper;
